import { SectionShell } from "@/components/dash/primitives";

export default function Implications({ data, num, title }) {
  return (
    <SectionShell id="implications" num={num} title={title}>
      <p className="font-num text-xs uppercase tracking-[0.2em] text-slate-500 mb-8">{data.intro}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {data.cards.map((c, i) => (
          <div
            key={i}
            data-testid={`implication-card-${i + 1}`}
            className="relative bg-white border border-slate-200 rounded-xl p-7 overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-slate-300"
          >
            <span className="absolute -top-4 right-3 font-display text-8xl font-bold text-slate-100 select-none pointer-events-none">
              {c.num}
            </span>
            <div className="relative">
              <h3 className="font-display text-lg font-semibold text-slate-900 leading-tight pr-12">{c.title}</h3>
              <p className="text-sm text-slate-600 mt-3 leading-relaxed">{c.text}</p>
            </div>
          </div>
        ))}
      </div>
    </SectionShell>
  );
}
